import axios from 'axios'
import { getVelascaApiUrl } from '@velasca/utils/get-velasca-api-url'

const velascaApiUrl = getVelascaApiUrl(process.env.NODE_ENV)

export const requestNotification = async (
  sku: string,
  email: string,
  product_url: string,
  language: string,
  subsidiary: number,
  store_netsuite_id: number,
) => {
  const data = {
    sku,
    email,
    product_url,
    language,
    subsidiary,
    store_netsuite_id,
  }

  const response = await axios.post(`${velascaApiUrl}/notify-me`, data)

  return response
}
